function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { useI18nContext } from '../_hooks/I18n';
export var useCloseWithConfirmState = function useCloseWithConfirmState() {
  var I18n = useI18nContext();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFormDifferent = _React$useState2[0],
    setFormIsDifferent = _React$useState2[1];
  var closeWithConfirm = React.useCallback(function (onClose) {
    return onClose ? function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (isFormDifferent && onClose) {
        if (window.confirm(I18n.t('core.form.closeWithConfirm.confirmMessage'))) {
          return onClose.apply(void 0, args);
        }
      } else {
        return onClose === null || onClose === void 0 ? void 0 : onClose.apply(void 0, args);
      }
    } : undefined;
  }, [isFormDifferent]);
  return {
    closeWithConfirm: closeWithConfirm,
    setFormIsDifferent: setFormIsDifferent
  };
};
export var CloseWithConfirmContext = /*#__PURE__*/React.createContext({
  setFormIsDifferent: function setFormIsDifferent() {},
  // @ts-ignore
  closeWithConfirm: function closeWithConfirm(onClose) {
    return onClose;
  }
});
export var useCloseWithConfirmContext = function useCloseWithConfirmContext() {
  return React.useContext(CloseWithConfirmContext);
};
//# sourceMappingURL=closeWithConfirm.js.map